<script>
	// 필요한 이미지나 데이터를 여기서 임포트
</script>

<div class="academic-container">
	<h1>Academic Ability</h1>
	<div class="education-list">
		<div class="education-item">
			<h2>Gyeonggi Changjo High School</h2>
			<p class="period">2022 - 2024</p>
			<p class="degree">Natural Sciences</p>
			<p class="details">I followed a science-focused curriculum and consistently maintained strong grades throughout my time at Gyeonggi Creative High School.</p>
		</div>

        <div class="education-item">
			<h2>The Cyber University of Korea</h2>
			<p class="period">2025 - Present</p>
			<p class="degree">B.S. in Software Engineering</p>
			<p class="details">Currently pursuing a degree in Software Engineering, deepening my understanding of programming, algorithms, and real-world development practices.</p>
		</div>
		
		<!-- 필요에 따라 더 많은 학력 정보 추가 -->
	</div>
</div>

<style>
	.academic-container {
		max-width: 800px;
		margin: 80px auto 0;
		padding: 0 20px;
	}

	h1 {
		font-size: var(--font-size-title, 2rem);
		margin-bottom: 1.5rem;
		color: var(--color-text, #000000);
	}

	.education-list {
		display: flex;
		flex-direction: column;
		gap: 2rem;
	}

	.education-item {
		border-left: 3px solid #000;
		padding-left: 1rem;
	}

	h2 {
		margin: 0 0 0.5rem 0;
		font-size: 1.5rem;
        border-bottom: 1px solid #eee;
	}

	.period {
		color: #666;
		margin: 0 0 0.5rem 0;
	}

	.degree {
		font-weight: bold;
		margin: 0 0 0.5rem 0;
	}

	.details {
		margin: 0;
	}
</style>